import React from 'react';

import { getErrorMessage } from '~libs/axiosWrapper';

import { ContainerState } from '~components';

import { DASHBOARD_TEXT } from './dashboardText';
import { DashboardWidgetStatus, MUTED_GREY } from './dashboardWidgets';

interface ComponentProps {
  status: DashboardWidgetStatus;
  /** The card's title, for Retry's accessible name */
  title: string;
  dataCy: string;
}

const copy = DASHBOARD_TEXT.widget;

const SPINNER = { type: 'beat', size: 10, color: MUTED_GREY } as const;

/**
 * What a Dashboard card shows in place of its figures: a grey spinner while they load, or the error with a
 * Retry button. The card's title stays. Renders nothing when ready.
 */
export const DashboardWidgetState: React.FC<ComponentProps> = ({ status, title, dataCy }) => {
  if (status.phase === 'ready') return null;

  return (
    <ContainerState
      error={status.phase === 'error' ? copy.failed(getErrorMessage(status.error)) : undefined}
      onRetry={status.retry}
      retryText={copy.retry}
      retryLabel={copy.retryLabel(title)}
      spinnerProps={SPINNER}
      loadingDataCy={`${dataCy}-loading`}
      errorDataCy={`${dataCy}-error`}
      retryDataCy={`${dataCy}-retry`}
    />
  );
};
